import { Link } from "react-router-dom";

/** Datum aus YYYY-MM-DD → "22. Juni 2025" */
function formatDatum(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  const monate = ["","Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
  return `${parseInt(d)}. ${monate[parseInt(m)]} ${y}`;
}

export default function NewsCard({ artikel }) {
  const bildUrl = artikel.photoUrls?.[0] || null;
  const kurztext = (artikel.text || "").slice(0, 140);

  return (
    <Link
      to={`/news/${artikel.slug}`}
      className="group block bg-white border border-black/5 shadow-sm hover:shadow-md transition-shadow overflow-hidden"
    >
      {bildUrl && (
        <div className="overflow-hidden h-48">
          <img
            src={bildUrl}
            alt={artikel.title}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      )}
      <div className="p-6">
        <div className="flex items-center gap-3 mb-3 flex-wrap">
          {artikel.kategorie && (
            <span className="bg-accent/10 text-accent text-xs font-bold uppercase tracking-wide px-2 py-1">
              {artikel.kategorie}
            </span>
          )}
          {artikel.opponent && (
            <span className="text-xs text-dark/50 font-semibold">
              vs {artikel.opponent}{artikel.score ? ` — ${artikel.score}` : ""}
            </span>
          )}
          <span className="text-xs text-dark/50">{formatDatum(artikel.date)}</span>
        </div>
        <h3 className="text-xl font-bold leading-snug group-hover:text-primary transition-colors">
          {artikel.title}
        </h3>
        {kurztext && (
          <p className="mt-3 text-sm text-dark/70 leading-relaxed line-clamp-3">
            {kurztext}{artikel.text?.length > 140 ? "…" : ""}
          </p>
        )}
        <span className="mt-4 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wide text-primary group-hover:text-accent transition-colors">
          Weiterlesen
          <svg className="h-3 w-3" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </span>
      </div>
    </Link>
  );
}
